import { BlogArticle } from '../types';
import dictationLastMinuteTips from './dictation-tips';
import dseCountdownPlan from './dse-countdown-study-plan';
import commonEnglishMistakes from './common-english-mistakes-hk';
import spacedRepetition from './spaced-repetition-flashcards';
import ieltsWritingTask2 from './ielts-writing-task2-band7';
import listeningDaily from './listening-practice-daily';
import speakingShadowing from './speaking-shadowing-method';
import pdfNotes from './pdf-notes-organize';
import examTimeManagement from './exam-time-management';
import activeRecall from './active-recall-vs-rereading';
import dseEnglishPaper2 from './dse-english-paper2-guide';

// ============================================================================
// Article registry. To publish a new article:
//   1. Create `articles/<your-article>.ts` exporting a BlogArticle (see the
//      demo file `dictation-tips.ts` for the format).
//   2. Import it here and add it to the list — newest first.
// ============================================================================

const articles: BlogArticle[] = [
  dictationLastMinuteTips, // 2026-09-22
  dseCountdownPlan, //        2026-09-21
  commonEnglishMistakes, //   2026-09-18
  spacedRepetition, //        2026-09-15
  ieltsWritingTask2, //       2026-09-12
  listeningDaily, //          2026-09-09
  speakingShadowing, //       2026-09-06
  pdfNotes, //                2026-09-03
  examTimeManagement, //      2026-08-31
  activeRecall, //            2026-08-28
  dseEnglishPaper2, //        2026-08-25
];

export default articles;
